import React from 'react';
import "./chat.css";

const DateHeader = ({ date, isVisible }) => {
    return (
        <div className={`dateHeader ${isVisible ? '' : 'hidden'}`}>
            <span>{date}</span>
        </div>
    );
};

export default DateHeader;
